import React from 'react';
import KioskSummary from './KioskSummary';
import HostSummary from './HostSummary';
import KioskApps from './KioskApps';
import ServerApps from './ServerApps';
import HostApps from './HostApps';
import DockerContainers from './DockerContainers';
import Kskapi from './Kskapi';
import CupsPrinter from './CupsPrinter';
import Kskdb from './Kskdb';
import KskdbTableCount from './KskdbTableCount';
import KskdbMenu from './KskdbMenu';
import SosdbKiosk from './SosdbKiosk';

class HostDetailBody extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let { hostInfo } = this.props;

    let opacity = hostInfo.isBadFetchStatus ? 0.5 : 1;

    return (
      <div style={{ opacity: opacity }}>
        <HostSummary {...this.props} hideCPUInfo={hostInfo.hasKioskInfo} />

        {hostInfo.hasContainers ? <DockerContainers {...this.props} /> : null}

        {hostInfo.hasSvrApp && !hostInfo.hasKioskInfo ? <ServerApps {...this.props} /> : null}

        {!hostInfo.hasKioskInfo ? <HostApps {...this.props} /> : null}

        {hostInfo.hasKioskInfo ? <KioskSummary {...this.props} /> : null}

        {hostInfo.hasKioskInfo ? <KioskApps {...this.props} /> : null}

        {hostInfo.hasKioskInfo ? <Kskapi {...this.props} /> : null}

        {hostInfo.hasKioskInfo &&
        hostInfo.kioskInfo.cups &&
        hostInfo.kioskInfo.cups.hasOwnProperty('pendingPrintJobs') ? (
          <CupsPrinter {...this.props} />
        ) : null}

        {hostInfo.hasKioskInfo ? <KskdbTableCount {...this.props} /> : null}

        {hostInfo.hasKioskInfo ? <Kskdb {...this.props} /> : null}

        {hostInfo.hasKioskInfo ? <KskdbMenu {...this.props} /> : null}

        {hostInfo.sosdbKiosk && Object.keys(hostInfo.sosdbKiosk).length ? (
          <SosdbKiosk {...this.props} />
        ) : null}

        {hostInfo.hasKioskInfo ? <HostApps {...this.props} /> : null}
      </div>
    );
  }
}

export default HostDetailBody;



// WEBPACK FOOTER //
// ./src/components/HostDetailBody.js